import { Component, OnInit } from '@angular/core';
import { HomeService } from '../shared/home.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: 'home.component.html',
  styleUrls: ['home.component.css']
})
export class HomeComponent implements OnInit {
  segmento: any;
  appLogo: string;
  

  constructor(
   
    private homeService: HomeService,
    private router: Router) { }

  ngOnInit(): void {

    this.homeService.getSegmento().subscribe(data => {

      this.segmento = data.body;

      //verifica se é tenant educacional
      if (this.segmento ==2) {

        let rota = 'pedagogico/matriculometro';
        this.appLogo = './assets/images/saguiedu-logo-login.png';

        //verifica se tem acesso ao matriculometo
        this.homeService.getAcessoFuncionalidade(rota).subscribe(data => {
          if (data.body) {
            this.router.navigate([rota]);
          } 
        });
     
      }else{
        if(this.segmento == 3){
          this.appLogo = './assets/images/saguilog-logo-login.png';

        }else{
          this.appLogo = './assets/images/saguicontrol-logo-login.png';
        }
        this.router.navigate(['/home-saguicontrol']);
      }

    });
      
     
  }

}

